export const UPDATE_CURRENT_MESSAGE = 'UPDATE_CURRENT_MESSAGE';
